/**
 * The session storage keys that will be used in different parts of Join Now.
 */

/* eslint-disable import/prefer-default-export */
export const STORAGE_KEYS = {
  JOIN_NOW: {
    JOIN_NOW_VISITED: 'join-now-visited',
    FEATURE: 'join-now-form',
    PAGE: 'join-now-page',
    VALIDITY: 'join-now-page-validity',
    QUOTE_ID: 'join-now-quote-id',
    POLICY_HOLDER_FEATURE: 'policy-holder-form',
    PARTNER_FEATURE: 'partner-form',
    CHILDREN_FEATURE: 'children-form',
    ELIGIBILITY: {
      CURRENTLY_SERVING: 'eligibility-form-adf',
      EX_SERVING: 'eligibility-form-ex-serving',
      SUPPORTING: 'eligibility-form-supporting',
      WORK_CONNECTION: 'eligibility-form-work-connection',
    },
    REBATE_FEATURE: 'rebate-form',
    FUTURE_PAYMENT: {
      FEATURE: 'future-payment-form',
      CREDIT_CARD: 'future-payment-credit-card-info',
    },
    CONFIRMATION_FEATURE: 'confirmation-form',
  },
  MEMBERSHIP_STATUS: {
    CREATION_DETAILS: 'membership-creation-details',
    PRICE_DETAILS: 'membership-price-details',
    QUOTE_DETAILS: 'membership-quote-details',
    PAYMENT_DETAILS: 'membership-payment-details',
    MEMBERSHIP_VISITED: 'membership-created-visited',
  },
  CONTACT_US: {
    FORM_RESPONSE: 'contact-us-form-response',
  },
  EMAIL: {
    PHONE_TYPE: 'phone-type',
  },
  REFERRAL_ID: 'referral-id',
  MARKETING_ID: 'marketing-id',
  LANDING_PAGE_URL: 'landing-page-url',
  REDIRECT_LINK: 'redirect-link',
  // STEP_ONE_CONTACT: 'step-one-contact',
  STEP_ONE_RECOMMENDATIONS: 'step-one-recommendations',
  QUOTE_ID: 'quote-id',
  QUOTE_DETAILS: 'quote-details',
  QUOTE_REFINEMENT: 'quote-refinement',
  QUOTE_REFINEMENT_PRICE: 'quote-refinement-price',
  EMAIL_QUOTE_REDIRECT_LINK: 'email-quote-redirect-link',
};
